// extracted by mini-css-extract-plugin
module.exports = {"hero":"styles_hero__3yIlv","wrapper":"styles_wrapper__SsISo","tagline":"styles_tagline__2NZkL"};